<template>
    <div>
        <md-button class="md-raised" :disabled="isDisabledButton" @click="back" v-if="!showButtonFirstFormulario">Atras</md-button>  
        <md-button class="md-raised" :disabled="isDisabledButton" type="submit">{{Bottontitle}}</md-button>
        <md-button class="md-raised" :disabled="isDisabledButton" @click="SaveContinue" v-if="ShowButtonSaveContinue">
            <md-icon>save</md-icon>
        </md-button> 
    </div>  

</template>

<script>
import eventBus from '../bus'
export default {
    name:"Botonera",
    data: () => ({
        isDisabledButton: false
    }),
    props: [ "data", "indexForm","back", "form", "Bottontitle", "hideBack"],
    mounted: function(){
        this.isDisabledButton = false
    },
    methods: {
        SaveContinue:function(){
            eventBus.$emit("saveandContinous", this.form)
        },
    },
    computed: {
        ShowButtonSaveContinue:function(){
            return this.$route.params.view == "promotor" ? true : false
        },
        showButtonFirstFormulario:function(){
            return (typeof(this.hideBack) === "undefined") ? false: this.hideBack;
        },

    },

    created(){
        var that = this
        eventBus.$on('buttonDisabled',(data)=>{
            that.isDisabledButton = data
        })
    },
}
</script>

<style>

</style>